import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "query", "results" ]
  static values = { url: String }

  disconnect() {
    this.resetSearch()
  }

  search() {
    if(this.query == "") {
      this.resetSearch()
      return
    }

    if(this.query == this.previousQuery) {
      return
    }
    this.previousQuery = this.query

    this.abortPreviousFetchRequest()

    const url = new URL(this.urlValue)
    url.searchParams.append("query", this.query)

    this.abortController = new AbortController()
    fetch(url, { signal: this.abortController.signal })
      .then(response => response.text())
      .then(html => {
        // eslint-disable-next-line no-unsanitized/property -- the response is a result list rendered by our own member controller
        this.resultsTarget.innerHTML = html
      })
      .catch(() => {})
  }

  // private

  abortPreviousFetchRequest() {
    if(this.abortController) {
      this.abortController.abort();
    }
  }

  resetSearch() {
    this.element.value = ""
    this.resultsTarget.innerHTML = ""
    this.previousQuery = null
  }

  get query() {
    return this.queryTarget.value
  }
}
